import styled from "styled-components";
import { Button, Modal } from "antd";
import { useTranslation } from "react-i18next";

import { TModalWithChildren } from "@interface/IModal";

const ModalCommon = ({
  visible,
  onOk,
  onCancel,
  loading = false,
  btnCancelText = "Home:btn.back",
  btnComfirmText = "Home:confirm",
  children,
}: TModalWithChildren) => {
  const [t] = useTranslation();
  return (
    <Contents id="modal-confirm-cancel">
      <Modal
        open={visible}
        onOk={() => (loading ? {} : onOk())}
        onCancel={() => (loading ? {} : onCancel())}
        getContainer={() =>
          document.getElementById("modal-confirm-cancel") as HTMLElement
        }
        closable={false}
        centered
        footer={
          <>
            <Button type="text" onClick={onCancel} disabled={loading}>
              {t(btnCancelText)}
            </Button>
            <Button
              type="primary"
              onClick={onOk}
              className="footer-save"
              disabled={loading}
            >
              {t(btnComfirmText)}
            </Button>
          </>
        }
      >
        {children}
      </Modal>
    </Contents>
  );
};

export default ModalCommon;

const Contents = styled.div`
  .ant-modal {
    top: 15px;
    width: 480px;
  }
  .ant-modal-content {
    box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 50%);
    border-radius: 0.3rem;
  }
  .ant-modal-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 0 0 0.3rem 0.3rem;
    padding: 18px 24px;
    .ant-btn-text {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 120px;
      :hover {
        opacity: 1;
      }
    }
    .ant-btn-text[disabled],
    .ant-btn-text[disabled]:active,
    .ant-btn-text[disabled]:focus,
    .ant-btn-text[disabled]:hover {
      color: rgba(0, 0, 0, 0.25);
      > svg > path {
        stroke: rgba(0, 0, 0, 0.25);
        fill: rgba(0, 0, 0, 0.25);
      }
    }
  }
  .ant-modal-body {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .text {
    font-size: 22px;
    margin: 5px 0;
  }
`;
